<template>
    <div>
        <div v-html="user_content"></div>
        <!-- <p><b>一、引言</b></p>
        <p>欢迎您使用成都方大软件有限公司（以下简称“
            测试服”）开发的移动应用程序（以下简称“本应用”）。在您下载、安装、使用本应用前，请仔细阅读本《用户协议》（以下简称“本协议”）的所有内容，特别是加粗部分。本协议是您（以下简称“用户”）与方大软件之间关于用户下载、安装、使用、复制本应用的法律协议。
        </p>
        <p><b>二、协议接受</b></p>
        <p>用户开始使用本应用前，应当阅读并接受本协议。用户下载、安装、使用、登录本应用即视为已阅读并同意本协议的约束。方大软件有权在必要时修改本协议条款。您可以在本应用的相关页面查找最新版本的协议条款。本协议条款修改后，如果您继续使用本应用，即视为您已接受后的协议。
        </p>
        <p><b>三、使用规范</b></p>
        <p>用户在使用本应用时，必须遵守国家的法律法规，不得利用本应用进行任何非法目的的活动。用户不得通过任何方式对本应用进行逆向工程、逆向编译等。用户应当保管账号信息及密码，因用户泄露而造成的损失由用户自行承担。用户同意大软件收集和使用用户在使用服务时提供的一些信息，如本协议中所述。
        </p>
        <p><b>四、知识产权声明</b></p>
        <p>本应用的一切版权、商标权、专利权、商业机密等知识产权，以及与应用相关的所有信息内容（包括文字、图片、音频、视频、图标、界面设计等）人一切，受法律保护。未经方大软件未授权人书面同意，用户不得以任何营利或商业性复制为目的、修改、传播、展示本应用。
        </p>
        <p><b>五、免责声明</b></p>
        <p>方大软件不保证本应用符合用户的使用要求，也不保证本应用不会被中断，对应用的及时性、安全性、错误发生以及信息是否准确、及时、以上不作保证。用户理解并同意，因业务发展需要，方大软件保留随时对本应用及其服务内容进行调整、更新的权利。
        </p>
        <p><b>六、法律适用与争议解决</b></p>
        <p>本协议的订购、执行和解释及争议的解决均适用中华人民共和国法律。如双方就本协议内容发生任何争议，双方应相互协商解决；协商不成时，各方期待双方大软件驻地的人民法院提起诉讼。</p>
        <p><b>七、其他</b></p>
        <p>如果本协议中的任何条款因任一原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效且具有约束力。本协议解释权及修订权归成都方大软件有限公司所有。感谢您的理解与支持。希望您使用本应用程序中能够愉快！<br />
        </p> -->
    </div>
</template>
<script>
import { appConfigPub } from '@/api/app'
export default {
    data(){
        return {
            user_content:''
        }
    },
    created(){
        this.getAppConfig()
    },
    methods:{
        async getAppConfig(){
            const res = await appConfigPub()
            if(res.code == 1){
                this.user_content = res.data.user_content
            }
        }
    }
}
</script>